import { render, staticRenderFns } from "./UsageDataTopTenPieChart.vue?vue&type=template&id=c5be004e&scoped=true&"
import script from "./UsageDataTopTenPieChart.vue?vue&type=script&lang=js&"
export * from "./UsageDataTopTenPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5be004e",
  null
  
)

export default component.exports